import React from 'react';
import { Route, Routes } from 'react-router';

function MultipleRoute({ paths, element, ...rest }) {
  return (
    <Routes>
      {paths.map((path) => (
        <Route key={path} path={path} element={element} {...rest} />
      ))}
    </Routes>
  );
}

export default MultipleRoute;
